<p class="intro">
  Verfolgen Sie hier den Status Ihrer Lieferungen von gestern und heute inklusive Tourendetails,
  voraussichtlicher Ankunftszeit und zugehöriger Belege.
</p>

<mat-button-toggle-group [value]="daysBack()" (change)="daysBack.set($event.value)" aria-label="Tag">
  <mat-button-toggle [value]="1">Gestern</mat-button-toggle>
  <mat-button-toggle [value]="0">Heute</mat-button-toggle>
</mat-button-toggle-group>

@if (loading()) {
  <mat-spinner [diameter]="50"/>
}

@for (tour of tours(); track tour.tour_id) {
  <app-tour-card
    [tour]="tour"
    [daysBack]="daysBack()"
    [highlight]="tour.tour_id === current()?.tour_id"
    [updatedAt]="tour.tour_id === current()?.tour_id ? lastUpdated() : null"
    (download)="tracking.downloadInvoice($event, tour.tour_id)"
    (details)="openDetails($event)"/>
} @empty {
  @if (!loading()) {
    <p>Für diesen Tag liegen keine Lieferungen vor.</p>
  }
}
